import * as Sentry from '@sentry/browser';
import { useEffect, useState, createContext } from 'react';

import RequestService from 'services/RequestService';

const FeatureFlagContext = createContext();

export const FeatureFlagProvider = ({ featureFlags = {}, children }) => {
  const [adjustedFeatureFlags, setAdjustedFeatureFlags] = useState({
    ...featureFlags,
    consoleOpen: false,
  });

  useEffect(() => {
    const getFeatureFlags = async () => {
      const response = await RequestService.v3.getFeatureFlags();
      if (response.ok && response.featureFlags) {
        setAdjustedFeatureFlags(state => ({ ...state, ...response.featureFlags }));

        const flagsIntegration = Sentry.getClient()?.getIntegrationByName('FeatureFlags');
        if (flagsIntegration) {
          for (let key in response.featureFlags) {
            if (typeof response.featureFlags[key] === 'boolean')
              flagsIntegration.addFeatureFlag(key, response.featureFlags[key]);
          }
        } else {
          Sentry.captureException('Error setting feature flags');
        }
      }
    };

    getFeatureFlags();
  }, []);

  const context = {
    featureFlags: adjustedFeatureFlags,
    setAdjustedFeatureFlags,
  };

  return <FeatureFlagContext.Provider value={context}>{children}</FeatureFlagContext.Provider>;
};

FeatureFlagProvider.propTypes = {
  featureFlags: PropTypes.object,
  children: PropTypes.node.isRequired,
};

export default FeatureFlagContext;
